import { formatAxiosAdminError } from '@/api';

/** Единый текст ошибки для панели админа (сеть, 401, 500, миграции). */
export function formatAdminPanelError(e: unknown, fallback: string): string {
  return formatAxiosAdminError(e, fallback);
}
